import { IIdCodeTitle } from '@common/types';

/** Body types {Line} = [4, 50, 51] */
const LINE_51_BODY_TYPE_CODES = new Set([
  '4X4',
  'MINIVAN',
  'PICKUP',
  'SEDAN',
  'STATION',
  'SUV',
  'TRUCK',
  'VAN'
]);

const normalizeBodyTypeCode = (code?: string | null) =>
  code?.trim().toUpperCase() ?? '';

export function filterMotorBodyTypesByLine(
  bodyTypes: IIdCodeTitle[],
  lineCode: string
): IIdCodeTitle[] {
  if (lineCode?.trim() !== '51') {
    return bodyTypes ?? [];
  }

  return (bodyTypes ?? []).filter((bodyType) =>
    LINE_51_BODY_TYPE_CODES.has(normalizeBodyTypeCode(bodyType.code))
  );
}
